import {actionTypes} from '../../../types';

// Action creator for generating OTP request
export const verifyMobileOtp = (payload) => ({
    type: actionTypes.VERIFY_MOBILE_OTP_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const verifyMobileOtpSuccess = (payload) => ({
    type: actionTypes.VERIFY_MOBILE_OTP_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const verifyMobileOtpFailure = (payload) => ({
    type: actionTypes.VERIFY_MOBILE_OTP_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const verifyMobileOtpReset = () => ({
    type: actionTypes.VERIFY_MOBILE_OTP_RESET,
});

// Action creator for resetting all OTP generation reducer
export const verifyMobileOtpResetAll = () => ({
    type: actionTypes.VERIFY_MOBILE_OTP_RESET_ALL,
});
